type Severity = 'success' | 'info' | 'warn' | 'error' | string | undefined;

function severityClasses(severity: Severity) {
  return {
    'bg-notify-success-surface border-notify-success-border text-notify-success-fg': severity === 'success',
    'bg-notify-error-surface border-notify-error-border text-notify-error-fg': severity === 'error',
    'bg-notify-warning-surface border-notify-warning-border text-notify-warning-fg': severity === 'warn',
    'bg-notify-info-surface border-notify-info-border text-notify-info-fg': severity === 'info',
  };
}

export const toastPt = {
  root: {
    class: 'fixed top-4 right-4 z-[9999] flex flex-col gap-3 w-80 pointer-events-none',
  },
  message: ({ props }: any) => ({
    class: [
      'pointer-events-auto flex items-start gap-3 rounded-notification border p-4 shadow-lg',
      severityClasses(props?.message?.severity),
    ],
  }),
  messageContent: { class: 'flex items-start gap-3 flex-1 min-w-0' },
  messageIcon: { class: 'size-5 shrink-0 mt-0.5' },
  messageText: { class: 'flex-1 min-w-0' },
  summary: { class: 'text-sm font-semibold block' },
  detail: { class: 'text-sm opacity-75 mt-1 block' },
  buttonContainer: { class: 'ml-1 shrink-0' },
  closeButton: { class: 'rounded-lg p-1 hover:opacity-60 transition-opacity focus:outline-none' },
  closeIcon: { class: 'size-3.5' },
};

export const messagePt = {
  root: ({ props }: any) => ({
    class: [
      'flex items-start gap-3 rounded-notification border p-4',
      severityClasses(props?.severity),
    ],
  }),
  content: { class: 'flex items-center gap-3 flex-1' },
  icon: { class: 'size-5 shrink-0' },
  text: { class: 'text-sm flex-1' },
  closeButton: { class: 'ml-auto rounded-lg p-1 hover:opacity-60 transition-opacity focus:outline-none' },
  closeIcon: { class: 'size-4' },
};
